import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "antd";

@autobind
/**
 *
 */
export default class MaterialIcon extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string,
    onClick: PropTypes.func,
    size: PropTypes.oneOf([
      "tiny", "small", "medium", "large",
    ]),
    style: PropTypes.object,
    className: PropTypes.string,
    spin: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
  };

  static defaultProps = {
    name: "help",
    style: {},
    className: "",
    spin: false,
    disabled: false,
  };

  /**
   *
   * @return {Object}
   * @private
   */
  get _style() {
    const { size, style } = this.props;
    let fontSize = 0;

    switch (size) {
      case "large":
        fontSize += 2;
      case "medium":
        fontSize += 2;
      case "small":
        fontSize += 1;
      case "tiny":
        fontSize += 1;
        fontSize += "rem";
        break;
      default:
        fontSize = "";
    }

    return Object.assign(
      {
        fontSize,
      },
      style,
    );
  }

  /**
   *
   * @param {*} event
   * @private
   */
  _onClick(event) {
    const { onClick, disabled } = this.props;

    if (onClick) {
      event.stopPropagation();

      if (!disabled) onClick(event);
    }
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const { name, onClick, className, spin, disabled, tooltip } = this.props;

    const _icon = (
      <i
        ref={(input) => this._node = input}
        onClick={this._onClick}
        className={`mdi mdi-${name} ${spin && "anticon-spin"} ${className} ${onClick ? "click" : ""} ${disabled ? "disabled" : ""}`}
        style={this._style}
      />
    );

    return tooltip ? (
      <Tooltip
        title={tooltip}
        getPopupContainer={() => this._node}
      >
        {_icon}
      </Tooltip>
    ) : _icon;
  }
}
